import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AppState } from './types';
import { RootState } from '@/store/types';

export const state: AppState = {
  isShowUserSettings: false,
  isShowCredentials: false,
  isShowChangePassword: false,
  links: {
    feedback: '',
    learnMore: '',
  },
  isShowSignOutDialog: false,
  isWriteBacklogAudio: true,
  isWriteBacklogVideo: true,
  turnServer: '',
  turnUser: '',
  turnCredential: '',
  useTurnServer: false,
  testMode: false,
  showSignerPrompt: false,
  showGloss: false,
  allowMessageEditing: true,
  isModelPickerEnabled: false,
  showInstanceId: false,
  instanceId: '',
};

const namespaced = true;

export const app: Module<AppState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
